import React from 'react';

import ButtonComponent from '../../ButtonComponent/ButtonComponent';
import CustomTooltip from '../../CustomTooltip/CustomTooltip';

interface ModalCommonButtonsContainerInterface {
  submitButtonText: string | React.ReactNode;
  cancelButtonText?: string | React.ReactNode;
  onClose: () => void;
  onSave: () => void;
  loading?: boolean;
  disabled?: boolean;
  fontSize?: string | number;
  buttonStyle?: React.CSSProperties;
  gap?: string | number;
  className?: string;
  style?: React.CSSProperties;
  disabledTooltipText?: string;
  secondaryButtonClassName?: string;
  showSecondaryButton?: boolean;
  primaryButtonClassName?: string;
}

const ModalCommonButtonsContainer: React.FC<ModalCommonButtonsContainerInterface> = ({
  submitButtonText,
  cancelButtonText = 'Cancel',
  onClose,
  onSave,
  loading = false,
  disabled = false,
  fontSize = '16px',
  buttonStyle,
  className,
  style,
  disabledTooltipText = '',
  secondaryButtonClassName = '',
  showSecondaryButton = true,
  primaryButtonClassName = '',
}) => {
  return (
    <div className={`modal-common-buttons-container ${className}`} style={style}>
      {showSecondaryButton && (
        <ButtonComponent
          textStyle={{ fontSize }}
          style={buttonStyle}
          className={secondaryButtonClassName}
          variant="secondary"
          onClick={onClose}>
          {cancelButtonText}
        </ButtonComponent>
      )}
      <CustomTooltip
        show={
          disabled && Boolean(disabledTooltipText) && Boolean(disabledTooltipText && disabledTooltipText?.length > 0)
        }
        title={disabledTooltipText}>
        <ButtonComponent
          textStyle={{ fontSize }}
          style={buttonStyle}
          disabledStyle={{ fontSize }}
          showLoading={loading}
          disabled={disabled}
          className={primaryButtonClassName}
          onClick={() => {
            onSave();
          }}>
          {submitButtonText}
        </ButtonComponent>
      </CustomTooltip>
    </div>
  );
};

export default ModalCommonButtonsContainer;
